import Model from "../Model";

export interface TBoFormVersion {
  id: number;
  sendDate?: Date;
  status: string;
  version: number;
  regularCheckStatus?: string;
  forPublication: boolean;
  publicationDate?: Date;
  lngLanguageCode: string;
  numberItemElectronicRegistry?: string;
  subNumberItemElectronicRegistry?: string;
  formalCheckStatus?: string;
  sender?: string;
  digitallySigned?: boolean;
  signatureDate?: Date;
}

export interface IBoFormVersion extends TBoFormVersion {}

const BoFormVersion = Model((model: TBoFormVersion): IBoFormVersion => {
  const _boFormVersion: TBoFormVersion = Object.assign({}, model);

  return {
    get id() {
      return _boFormVersion.id;
    },

    get sendDate() {
      return _boFormVersion.sendDate;
    },

    set sendDate(value: any) {
      _boFormVersion.sendDate = value;
    },

    get status() {
      return _boFormVersion.status;
    },

    get version() {
      return _boFormVersion.version;
    },

    get regularCheckStatus() {
      return _boFormVersion.regularCheckStatus;
    },

    get forPublication() {
      return _boFormVersion.forPublication;
    },

    set forPublication(value) {
      _boFormVersion.forPublication = value;
    },

    get publicationDate() {
      return _boFormVersion.publicationDate;
    },

    set publicationDate(value) {
      _boFormVersion.publicationDate = value;
    },

    get lngLanguageCode() {
      return _boFormVersion.lngLanguageCode;
    },

    get numberItemElectronicRegistry() {
      return _boFormVersion.numberItemElectronicRegistry;
    },

    get subNumberItemElectronicRegistry() {
      return _boFormVersion.subNumberItemElectronicRegistry;
    },

    get sender() {
      return _boFormVersion.sender;
    },

    get formalCheckStatus() {
      return _boFormVersion.formalCheckStatus;
    },

    set formalCheckStatus(value) {
      _boFormVersion.formalCheckStatus = value;
    },

    get digitallySigned() {
      return _boFormVersion.digitallySigned;
    },

    set digitallySigned(value) {
      _boFormVersion.digitallySigned = value;
    },

    get signatureDate() {
      return _boFormVersion.signatureDate;
    },

    set signatureDate(value) {
      _boFormVersion.signatureDate = value;
    }
  };
});

export default BoFormVersion;
